import { render, staticRenderFns } from "./BinDetails.vue?vue&type=template&id=4884766f&scoped=true&"
import script from "./BinDetails.vue?vue&type=script&lang=js&"
export * from "./BinDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884766f",
  null
  
)

export default component.exports